import { render, staticRenderFns } from "./DestinationsTable.vue?vue&type=template&id=2f57f886&"
import script from "./DestinationsTable.vue?vue&type=script&lang=js&"
export * from "./DestinationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports